<template>
    <div class="data-table w-100">
        <div class="table-responsive">
            <table class="table mb-0">
                <thead>
                    <tr>
                        <th>Fecha</th>
                        <th>P.d.V.</th>
                        <th>Número</th>
                        <th>Cliente</th>
                        <th class="text-right">Monto</th>
                        <th class="text-right">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(rec, index) in receiptListFiltered" :key="index">
                        <td>{{ formatDate(rec.created_at) }}</td>
                        <td>{{ rec.pos }}</td>
                        <td><span class="data-table__primary">{{ rec.number }}</span></td>
                        <td>{{ rec.client_name }}</td>
                        <td class="text-right">$ {{ parseFloat(rec.total).toFixed(2) }}</td>
                        <td class="text-right">
                            <div class="table-action-group">
                                <a class="table-action-btn" :href="'/ventas/cobranzas/detalle-recibo/' + rec.cc_id" title="Ver detalle">
                                    <i class="bi bi-eye"></i>
                                </a>
                                <button type="button" class="table-action-btn" title="Descargar PDF" @click="getPDF(rec.cc_id, rec.number)">
                                    <i class="bi bi-filetype-pdf"></i>
                                </button>
                                <button type="button" class="table-action-btn" title="Cancelar pago" @click="cancelPayment(rec.cc_id)">
                                    <i class="bi bi-trash"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="receiptListFiltered.length === 0">
                        <td colspan="6" class="data-table__empty">Sin recibos para mostrar</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- PAGINACION -->
        <div class="data-table__footer">
            <div class="data-table__info">
                Página {{ page }} de {{ totalPages }}
            </div>
            <ul class="data-table__pagination">
                <li class="page-item" :class="{ disabled: page === 1 }">
                    <a class="page-link" href="#" @click.prevent="prevPage()"><i class="bi bi-chevron-left"></i></a>
                </li>
                <li v-if="(page - (pageInterval / 2)) > 0" class="page-item">
                    <a class="page-link" href="#" @click.prevent="prevPage()">…</a>
                </li>
                <template v-for="index in totalPages">
                    <li v-if="inIntervalPage(index)" :key="index" class="page-item" :class="{ active: page === index }">
                        <a class="page-link" href="#" @click.prevent="changePage(index)">{{ index }}</a>
                    </li>
                </template>
                <li v-if="totalPages > (page + (pageInterval / 2))" class="page-item">
                    <a class="page-link" href="#" @click.prevent="nextPage()">…</a>
                </li>
                <li class="page-item" :class="{ disabled: page >= totalPages }">
                    <a class="page-link" href="#" @click.prevent="nextPage()"><i class="bi bi-chevron-right"></i></a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

import moment from 'moment';
import myaxios from 'axios';


export default {
    props: ['client','fromDate','toDate','watchTarget'],
    data() {
        return {
            receiptList:[],
            recFilter:'',
            page:1,
            rowCount:9,
            totalItems:0,
            totalPages:1,
            pageInterval:22,
        }
    },
    mounted(){
        this.getReceiptList();
    },
    computed: {
        receiptListFiltered:{
            get: function () {
                let vm = this;
                return this.receiptList.filter(e => e.number.includes(vm.recFilter));
            }
        }
    },
    methods: {
        getReceiptList(){
            var vm= this;
            var outdata = {
                'client_id': vm.client,
                'fromDate':vm.fromDate,
                'toDate':vm.toDate,
                'page':vm.page,
                'rowCount':vm.rowCount
            };
            this.$http.post('/api/collections/getReceipts', outdata)
            .then(response => {
                if(response.data) {
                vm.receiptList = response.data.data.list;
                vm.totalItems=response.data.data.totalItems;
              }
            })
            .catch(error => {
              alert(error);
            })
        },
        cancelPayment(value){
            this.$emit('cancelPay',value);
        },
        formatDate(value){
            if (value){
                return moment(String(value)).format('DD/MM/YYYY');
            }
        },
        prevPage(){
            this.page = this.page-1;
            this.getReceiptList();
        },
        nextPage(){
            this.page = this.page +1;
            this.getReceiptList();
        },
        changePage(data){
            this.page = data;
            this.getReceiptList();
        },
        inIntervalPage(index){
            if(this.totalPages<=this.pageInterval){return true;}

            let limitprev = this.page - (this.pageInterval/2);
            let limitnext = this.page + (this.pageInterval/2);

            if(limitprev<0){
                limitprev=0;
                limitnext=this.pageInterval;
            }

            if(index>limitprev && index<limitnext){
                return true;
            }

            return false;
        },
        getPDF(id, receiptNumber){
            this.$http.get('/api/collections/checkReceiptPDF/' + id)
            .then(res => {
                const uninterceptedAxiosInstance = myaxios.create();
                uninterceptedAxiosInstance.get(res.data.data.urlInvoice, { responseType: 'blob' })
                .then((response) => {
                    const blob = new Blob([response.data], {type: 'application/pdf'});
                    const currentDate = new Date();
                    const formattedDate = currentDate.toLocaleDateString().replace(/\//g, '-');
                    const fileName = 'Recibo_'+ receiptNumber +'_'+this.receiptListFiltered[0].client_name + '_' + formattedDate + '.pdf';
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob)
                    link.download = fileName;
                    console.log(link.download);
                    link.click()
                    URL.revokeObjectURL(link.href)
                })
            })
        }
    },
    watch: {
      'client': {
          handler: function () {
              this.page=1;
              this.getReceiptList();
            }
      },
      'fromDate': {
          handler: function () {this.getReceiptList();}
      },
      'toDate': {
          handler: function () {this.getReceiptList();}
      },
      'watchTarget': {
          handler: function () {this.getReceiptList();}
      },
      'receiptList':{
          handler: function(){
              this.totalPages = Math.ceil(this.totalItems / this.rowCount);
          }
      }
  },

}
</script>
